export default "__VITE_ASSET__BCvRj6KJ__"